import { PageSubscriptions } from "./Components/PageSubscriptions/PageSubscriptions";

export const PagePlansConfig = () => {
  return <PageSubscriptions />;
};
